module.exports = __webpack_public_path__ + "img/meter.f7422e15.svg";